import { useMount, useRequest } from 'ahooks';
import { themeStore, userStore } from './store/index.js';
import { getCurrentUserInfo, getThemeView, updateDept } from './service/theme.js';
import { Toast } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import useUrlSearch from './utils/useUrlSearch.js';

export default function useAppService(b) {

    const { deptName, page, pageSize } = userStore;

    const navigate = useNavigate();
    const { getByKey } = useUrlSearch()

    const { loading: loadingUser, run: runGetUserInfo } = useRequest(() => getCurrentUserInfo(), {
        manual: true,
        onSuccess: (res, param) => {
            if (res.status) {
                // userStore.token = res.data.token
                userStore.deptName = res.data.deptName ? res.data.deptName : '选择部门'
                userStore.deptId = res.data.dept
                userStore.lineId = res.data.lineId
                userStore.waitForExamKnowledgeId = res.data.knowledgeId
                if (res.data.lineId !== null) {
                    navigate('/')
                }
                if(res.data.lineId === null){
                    navigate('/line')
                }
            }else {
                Toast.show({
                    content: res.msg || '账号不存在',
                })
            }
        },
    })

    useMount(() => {
        if (b) {
            const userId = getByKey('userNumber')
            if (userId) {
                localStorage.setItem('userId', userId)
                userStore.userId = userId;
                runGetUserInfo()
            }
        }
    })

    const { run: runTheme } = useRequest(() => getThemeView({
        page,
        pageSize,
    }), {
        manual: true,
        onSuccess: (result, params) => {
            if (result.status) {
                const rows = result.data.rows;
                const rows_company = rows.filter(a => a.aslevel === 'Company')
                themeStore.company = rows_company
                themeStore.dept = rows.filter(a => a.aslevel === 'Deptment')
                themeStore.isCompanyFinished = rows_company.filter(a => a.knowledgeTestedNumber === a.totalNumber).length === rows_company.length && rows_company.length !== 0
            }else{
                Toast.show({
                    content: result.msg || '出错了',
                })
            }
        },
        onError: (error) => {
            Toast.show({
                content: '请求课程出错了',
            })
        }
    });


    const { loading: runUpdDeptLoading, run: runUpdateDept } = useRequest(({ deptId, deptName }) => updateDept({
        deptId,
        deptName
    }), {
        manual: true,
        onSuccess: (res, param) => {
            if (res.status) {
                Toast.show({
                    content: '更新部门成功',
                })
                userStore.deptName = param[0].deptName;
                userStore.deptId = param[0].deptId
            } else {
                Toast.show({
                    content: '更新部门成功',
                })
            }
        }
    })

    return { runGetUserInfo, loadingUser, runTheme, runUpdateDept, deptName, runUpdDeptLoading }

}
